__webpack_require__.p = "https://search.prod.wiggot.com/_next/";